import { ContactTypeParam } from '@views/contacts/enum/contactTypeParam'

import { ORGANIZATION_URL_PLACEHOLDER } from '../../../../../constants/organizationUrlPlaceholder'
import { EmberRoute } from '../../../../../enums/emberRoute'
import { isEmberRoute } from '../../../../../utils/routing/isEmberRoute'
import { NavigationMenuId } from '../enums/navigationMenuId'
import { NavigationMenuItemId } from '../types/NavigationMenuItemId'

interface TransformRouteToUrlArgs {
  convertEmberRouteToUrl: (route: EmberRoute) => string
  id: NavigationMenuItemId
  organizationUrl?: string
  route: string
}

export const transformRouteToUrl = ({
  convertEmberRouteToUrl,
  id,
  organizationUrl,
  route,
}: TransformRouteToUrlArgs): string => {
  if (isEmberRoute(route)) {
    const convertedEmberRouteToUrl = convertEmberRouteToUrl(route)

    if (id === NavigationMenuId.Suppliers) {
      return `${convertedEmberRouteToUrl}?${ContactTypeParam.Supplier}`
    }

    if (id === NavigationMenuId.Clients) {
      return `${convertedEmberRouteToUrl}?${ContactTypeParam.Customer}`
    }

    return convertedEmberRouteToUrl
  }

  if (!organizationUrl) {
    throw new Error(`transformRouteToUrl: organizationUrl is required for non-Ember routes (got "${route}")`)
  }

  return route.replace(ORGANIZATION_URL_PLACEHOLDER, organizationUrl)
}
